import QRCode from 'qrcode';
import { defineComponent, ref, watch } from 'vue';

const controller = defineComponent({
    name: 'QRCode',
    props: {
        stringToEncode: {
            type: String,
            default: '',
        },
    },
    setup(props) {
        const qrCodeSrc = ref(null);
        const setQRCode = async () => {
            if (!props.stringToEncode) {
                qrCodeSrc.value = null;
                return;
            }
            qrCodeSrc.value = await QRCode.toDataURL(props.stringToEncode);
        };
        watch(() => props.stringToEncode, setQRCode, { immediate: true });
        return {
            qrCodeSrc,
        };
    },
});

export { controller };
